module.exports = __webpack_public_path__ + "ico-crypto-sol.svg?4e6fecb2c83dd517ad34f5851b99ca82";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-sol.svg
// module id = 1161
// module chunks = 2